module.exports = __webpack_public_path__ + "static/figurine_of_wondrous_power_obsidian_steed-85b8285ed45164748f7e84b5d8b79a49.jpg";